import { Disclosure } from "@chef/components";
import { getStateStatus, RatingAndCommentCardState } from "./util";
import { intl } from "./RecipeComment.Intl";

interface RecipeCommentProps {
  initialComment: string;
  cardState: RatingAndCommentCardState;
  onToggleExpanded: () => void;
  onClickAddComment: () => void;
  isExpanded: boolean;
}

export const RecipeComment = ({
  initialComment,
  cardState,
  onToggleExpanded,
  onClickAddComment,
  isExpanded,
}: RecipeCommentProps) => {
  const { isRatingSavedWithComment, isRatingSavedWithoutComment } =
    getStateStatus(cardState);

  if (!isRatingSavedWithComment && !isRatingSavedWithoutComment) {
    return null;
  }

  if (isRatingSavedWithComment) {
    return (
      <Disclosure
        Title={() => (
          <span className="w-full text-xs">
            <strong>
              {isExpanded ? intl.HIDE_COMMENT : intl.SHOW_COMMENT}
            </strong>
          </span>
        )}
        open={isExpanded}
        onClick={onToggleExpanded}
        className="mt-7"
      >
        <div className="text-xs break-words">{initialComment}</div>

        <div
          className="w-full mt-4 text-xs underline cursor-pointer"
          onClick={onClickAddComment}
        >
          <strong>{intl.CHANGE_COMMENT}</strong>
        </div>
      </Disclosure>
    );
  }

  return (
    <div
      className="w-full text-xs underline cursor-pointer mt-7"
      onClick={onClickAddComment}
    >
      <strong>{intl.ADD_A_COMMENT}</strong>
    </div>
  );
};
